import { render, staticRenderFns } from "./NotificationSelect.vue?vue&type=template&id=3888027e"
import script from "./NotificationSelect.vue?vue&type=script&lang=js"
export * from "./NotificationSelect.vue?vue&type=script&lang=js"
import style0 from "./NotificationSelect.vue?vue&type=style&index=0&id=3888027e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports